<template>
	<div id="app">
		<title>{{$route.meta.title}}</title>
		<div
			v-show="showMenu"
			class="bg-black h-screen w-screen z-50 fixed flex flex-col justify-center items-center overflow-hidden"
		>
			<div class="absolute top-10">
				<img
					src="images/logos/logo_color.png"
					class="w-16"
				>
			</div>
			<div class="absolute top-10 right-16">
				<svg
					id="closemenu"
					@click="showMenu = false"
					class="hover:rotate-90 hover:bg-purple-500 rounded transform transition duration-500 right-10 w-8"
					xmlns="http://www.w3.org/2000/svg"
					fill="#FFF"
					viewBox="0 0 24 24"
					stroke="#FFF"
				>
					<path
						stroke-linecap="round"
						stroke-linejoin="round"
						stroke-width="2"
						d="M6 18L18 6M6 6l12 12"
					></path>
				</svg>
			</div>
			<div class="mt-10">
				<router-link
					@click.native="showMenu = false"
					to="/"
					class="text-white font-gilroy-extrabold text-xl"
				>Home</router-link>
			</div>
			<div class="mt-10">
				<router-link
					@click.native="showMenu = false"
					to="/about"
					class="text-white font-gilroy-extrabold text-xl"
				>About</router-link>
			</div>
			<div class="mt-10">
				<router-link
					@click.native="showMenu = false"
					to="/services"
					class="text-white font-gilroy-extrabold text-xl"
				>Services</router-link>
			</div>
			<div class="mt-10">
				<router-link
					@click.native="showMenu = false"
					to="/projects"
					class="text-white font-gilroy-extrabold text-xl"
				>Projects</router-link>
			</div>
			<div class="mt-10">
				<router-link
					@click.native="showMenu = false"
					to="/status"
					class="text-white font-gilroy-extrabold text-xl"
				>System status</router-link>
			</div>
			<div class="mt-10">
				<router-link
					@click.native="showMenu = false"
					to="/contact"
					class="text-white font-gilroy-extrabold text-xl"
				>Contact</router-link>
			</div>
		</div>

		<div class="max-w-7xl px-6 md:px-0 mx-auto z-30 relative">
			<header>
				<div class="flex">
					<div class="w-5/12 md:w-2/12">
						<div class="w-36 h-24 bg-white">
							<router-link to="/">
								<img
									class="w-20 ml-0 mt-2 md:mx-auto block"
									src="images/logos/logo_color.png"
								>
							</router-link>
						</div>
					</div>

					<div class="w-7/12 md:w-2/12 md:hidden">
						<svg
							@click="showMenu = true"
							id="openmenu"
							class="cursor-pointer w-8 mt-9 float-right"
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							stroke="currentColor"
						>
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								d="M4 6h16M4 12h16M4 18h16"
							/>
						</svg>
					</div>

					<div class="w-7/12 hidden mx-auto md:flex md:flex-row">
						<div class="text-center md:w-2/12 mr-4">
							<router-link
								to="/"
								class="mt-7 block align-middle text-black text-inter-400 text-sm"
							>Home</router-link>
						</div>
						<div class="text-center md:w-2/12 mr-4">
							<router-link
								to="/about"
								class="mt-7 block align-middle text-black text-inter-400 text-sm"
							>About</router-link>
						</div>
						<div class="text-center md:w-2/12 mr-4">
							<router-link
								to="/services"
								class="mt-7 block align-middle text-black text-inter-400 text-sm"
							>Services</router-link>
						</div>
						<div class="text-center md:w-2/12 mr-4">
							<router-link
								to="/status"
								class="mt-7 block align-middle text-black text-inter-400 text-sm"
							>System status</router-link>
						</div>
						<div class="text-center md:w-2/12 mr-4">
							<router-link
								to="/projects"
								class="mt-7 block align-middle text-black text-inter-400 text-sm"
							>Projects</router-link>
						</div>
					</div>

					<div class="hidden md:flex flex-initial relative">
						<div class=" align-middle inline-block">
							<router-link
								class="mt-4 block relative z-30 mx-auto bg-gradient-to-br from-blue-500 to-purple-700 text-inter-500 hover:scale-105 hue-rotate transition transform duration-500 text-white text-sm rounded-md py-4 px-4 aos-init aos-animate"
								to="/contact"
							>
								Estimate your project&nbsp; 🚀
							</router-link>
						</div>
					</div>
				</div>
			</header>
		</div>

		<router-view />

		<div class="max-w-7xl px-6 md:px-0 mx-auto z-30 relative">
			<div class="mt-32 border-t border-gray-200">
				<div class="grid grid-cols-2 md:grid-cols-4 py-5">
					<div>
						<router-link to="/home">
							<img
								src="images/logos/logo_color.png"
								class="w-28 block"
							>
						</router-link>
					</div>
					<div class="mt-7">
						<span class="block font-roboto-bold uppercase">Codestage SRL</span>
						<span class="block font-roboto-bold uppercase">TIN 41839507</span>
					</div>
					<div class="mt-6">
						<span class="block font-roboto-bold uppercase">FOCSANI</span>
						<span class="block font-roboto-regular">9 Unirii Boulevard</span>
						<span class="block font-roboto-regular">Focsani, VN, Romania</span>
					</div>
					<div class="mt-6">
						<span class="block font-roboto-bold uppercase">BUCHAREST</span>
						<span class="block font-roboto-regular">76 Unirii Boulevard</span>
						<span class="block font-roboto-regular">Bucharest, District 3</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style>
@tailwind base;
@tailwind components;
@tailwind utilities;

@font-face {
	font-family: "Gilroy-Light";
	src: url(../public/fonts/Gilroy-Light.woff);
}

@font-face {
	font-family: "Gilroy-ExtraBold";
	src: url(../public/fonts/Gilroy-ExtraBold.woff);
}

.font-roboto-bold {
	font-family: "Roboto";
	font-weight: 700;
}

.font-roboto-regular {
	font-family: "Roboto";
	font-weight: 500;
}

.font-gilroy-light {
	font-family: "Gilroy-Light";
}

.font-gilroy-extrabold {
	font-family: "Gilroy-ExtraBold";
}

/* compiled scss bcoz rapid dev */

.meteor-1 {
	position: absolute;
	top: 242px;
	left: 44%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 9.9s linear infinite;
}

.meteor-1:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-2 {
	position: absolute;
	top: 123px;
	left: 37%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 9.5s linear infinite;
}

.meteor-2:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-3 {
	position: absolute;
	top: 212px;
	left: 84%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 12.4s linear infinite;
}

.meteor-3:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-4 {
	position: absolute;
	top: 240px;
	left: 32%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 11.5s linear infinite;
}

.meteor-4:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-5 {
	position: absolute;
	top: 58px;
	left: 72%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 8.3s linear infinite;
}

.meteor-5:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-6 {
	position: absolute;
	top: 143px;
	left: 27%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 8.5s linear infinite;
}

.meteor-6:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-7 {
	position: absolute;
	top: 138px;
	left: 84%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 6.1s linear infinite;
}

.meteor-7:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-8 {
	position: absolute;
	top: 242px;
	left: 25%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 7.4s linear infinite;
}

.meteor-8:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-9 {
	position: absolute;
	top: 204px;
	left: 12%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 9s linear infinite;
}

.meteor-9:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-10 {
	position: absolute;
	top: 233px;
	left: 83%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 12.2s linear infinite;
}

.meteor-10:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-11 {
	position: absolute;
	top: 139px;
	left: 47%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 7.4s linear infinite;
}

.meteor-11:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-12 {
	position: absolute;
	top: 89px;
	left: 51%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 6.2s linear infinite;
}

.meteor-12:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-13 {
	position: absolute;
	top: 108px;
	left: 92%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 11s linear infinite;
}

.meteor-13:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-14 {
	position: absolute;
	top: 263px;
	left: 78%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 10.1s linear infinite;
}

.meteor-14:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-15 {
	position: absolute;
	top: 158px;
	left: 45%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 6.4s linear infinite;
}

.meteor-15:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-16 {
	position: absolute;
	top: 180px;
	left: 43%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 6.1s linear infinite;
}

.meteor-16:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-17 {
	position: absolute;
	top: 256px;
	left: 21%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 9.2s linear infinite;
}

.meteor-17:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-18 {
	position: absolute;
	top: 217px;
	left: 42%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 6.7s linear infinite;
}

.meteor-18:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-19 {
	position: absolute;
	top: 104px;
	left: 77%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 8.9s linear infinite;
}

.meteor-19:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-20 {
	position: absolute;
	top: 128px;
	left: 25%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 6.2s linear infinite;
}

.meteor-20:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-21 {
	position: absolute;
	top: 106px;
	left: 72%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 12.5s linear infinite;
}

.meteor-21:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-22 {
	position: absolute;
	top: 167px;
	left: 30%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 9.9s linear infinite;
}

.meteor-22:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-23 {
	position: absolute;
	top: 231px;
	left: 41%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 7.8s linear infinite;
}

.meteor-23:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-24 {
	position: absolute;
	top: 226px;
	left: 29%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 13s linear infinite;
}

.meteor-24:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-25 {
	position: absolute;
	top: 85px;
	left: 21%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 11.9s linear infinite;
}

.meteor-25:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-26 {
	position: absolute;
	top: 82px;
	left: 84%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 9.2s linear infinite;
}

.meteor-26:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-27 {
	position: absolute;
	top: 88px;
	left: 51%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 7.5s linear infinite;
}

.meteor-27:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-28 {
	position: absolute;
	top: 180px;
	left: 66%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 13s linear infinite;
}

.meteor-28:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-29 {
	position: absolute;
	top: 144px;
	left: 31%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 12.6s linear infinite;
}

.meteor-29:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-30 {
	position: absolute;
	top: 88px;
	left: 76%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 12.6s linear infinite;
}

.meteor-30:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-31 {
	position: absolute;
	top: 229px;
	left: 64%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 10.4s linear infinite;
}

.meteor-31:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-32 {
	position: absolute;
	top: 291px;
	left: 20%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 9.5s linear infinite;
}

.meteor-32:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-33 {
	position: absolute;
	top: 134px;
	left: 88%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 9.9s linear infinite;
}

.meteor-33:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-34 {
	position: absolute;
	top: 190px;
	left: 88%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 11.9s linear infinite;
}

.meteor-34:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-35 {
	position: absolute;
	top: 69px;
	left: 26%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 6.1s linear infinite;
}

.meteor-35:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-36 {
	position: absolute;
	top: 160px;
	left: 68%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 8.9s linear infinite;
}

.meteor-36:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-37 {
	position: absolute;
	top: 265px;
	left: 11%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 7.5s linear infinite;
}

.meteor-37:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-38 {
	position: absolute;
	top: 55px;
	left: 27%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 8.5s linear infinite;
}

.meteor-38:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-39 {
	position: absolute;
	top: 65px;
	left: 76%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 7.5s linear infinite;
}

.meteor-39:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.meteor-40 {
	position: absolute;
	top: 130px;
	left: 17%;
	width: 300px;
	height: 4px;
	transform: rotate(-45deg);
	background-image: linear-gradient(
		to right,
		#00fc81,
		rgba(255, 255, 255, 0)
	);
	animation: meteor 8.3s linear infinite;
}

.meteor-40:before {
	content: "";
	position: absolute;
	width: 4px;
	height: 5px;
	border-radius: 50%;
	margin-top: -2px;
	background: rgba(0, 252, 129, 0.7);
	box-shadow: 0 0 15px 3px #00fc81;
}

.animate__delay-700ms {
	animation-delay: 700ms;
}

@keyframes meteor {
	0% {
		opacity: 1;
		margin-top: -300px;
		margin-right: -300px;
	}

	12% {
		opacity: 0;
	}

	15% {
		margin-top: 300px;
		margin-left: -600px;
		opacity: 0;
	}

	100% {
		opacity: 0;
	}
}
</style>
<script>
/* eslint-disable */
/* eslint-enable */
</script>

<script>
export default {
	data() {
		return {
			showMenu: false
		}
	}
}
</script>